import moment from 'moment'
import {
  IActiveTripResponseV2,
  ILastActiveTrips,
  ILastActiveTripsByStages,
  IMap,
  ITripsHistory,
  ITripState,
  LOCAL_STORAGE_CURRENT_ORGANIZATION_KEY,
  TimelineViewDisplayType,
  WeatherDTO
} from '../../../types'
import { mergeMap } from '../../../utils/state'
import { ITripAction } from '../../actions/trips'
import * as constants from '../../constants/'

const initialState: ITripState = {
  isFetching: false,
  tempVehicleTripsCountFetching: false,
  importResults: {},
  items: {},
  filters: {
    timelineViewDisplay: TimelineViewDisplayType.DRIVER
  },
  lastActiveTrips: {},
  recentTrips: {},
  currentTripState: null,
  settings: {
    showMembers: false
  },
  currentTripId: '',
  tripStatusCount: [],
  selectedRows: [],
  updateDriverToggle: false,
  //Weather
  weather: {} as WeatherDTO,
  summaryFilters: {
    orgId: localStorage.getItem(LOCAL_STORAGE_CURRENT_ORGANIZATION_KEY) || '',
    timeField: 'pickup',
    timeFilter: 'Today',
    timeStart: moment()
      .startOf('day')
      .toISOString(),
    timeEnd: moment()
      .endOf('day')
      .toISOString()
  },
  summaryResults: { total: 0, items: [] },
  summaryItems: {},
  isOptimizeTripLoading: false,
  optimizeRouteResponse: null,
  optimizeTripResponse: null,
  temporaryVehicleResponse: null,
  scheduledReqiestTripsResponse: null,
  tempVehicleCountResponse: null,
  tempVehicleTripsCountResponse: null,
  sendingTripNotesUpdateNotification: false,
  sendingTripTimeUpdateNotification: false,
  sendingTripOperatorUpdateNotification: false,
  sendingTripCancelNotification: false,
  sendingAllottedTimeNotification: false
}

export function trips(state: ITripState, action: ITripAction): ITripState {
  if (typeof state === 'undefined') {
    return initialState
  }
  if (!action) {
    return state
  }

  switch (action.type) {
    case constants.GET_TRIPS_STATUS_COUNT_REQUEST:
    case constants.GET_DAILY_TRIP_LOG_REQUEST:
    case constants.GET_TOTAL_TRIPS_PER_SERVICE_REQUEST:
    case constants.SAVE_DATA_REQUEST:
    case constants.COMPLETE_TRIP_MANUALLY_REQUEST:
    case constants.CANCEL_BILLABLE_MANUALLY_REQUEST:
    case constants.TRIP_NO_SHOW_REQUEST:
    case constants.TRIP_CANCEL_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }

    case constants.COMPLETE_TRIP_MANUALLY_SUCCESS:
    case constants.CANCEL_BILLABLE_MANUALLY_SUCCESS:
    case constants.TRIP_NO_SHOW_SUCCESS:
    case constants.TRIP_CANCEL_SUCCESS: {
      const tripId = action.payload
      const items = Object.assign({}, state.items)
      delete items[tripId]
      return Object.assign({}, state, {
        items,
        isFetching: false
      })
    }

    case constants.TRIP_NOTES_PUSH_NOTIF_REQUEST: {
      return Object.assign({}, state, {
        error: undefined,
        sendingTripNotesUpdateNotification: true,
        success: undefined
      })
    }
    case constants.TRIP_NOTES_PUSH_NOTIF_SUCCESS_MESSAGE: {
      return Object.assign({}, state, {
        error: undefined,
        sendingTripNotesUpdateNotification: false,
        success: action.payload
      })
    }
    case constants.TRIP_NOTES_PUSH_NOTIF_FAIL: {
      return Object.assign({}, state, {
        error: action.payload,
        sendingTripNotesUpdateNotification: false
      })
    }

    case constants.TRIP_TIME_PUSH_NOTIF_REQUEST: {
      return Object.assign({}, state, {
        sendingTripTimeUpdateNotification: true
      })
    }
    case constants.TRIP_TIME_PUSH_NOTIF_SUCCESS_MESSAGE: {
      return Object.assign({}, state, {
        sendingTripTimeUpdateNotification: false,
        success: action.payload
      })
    }
    case constants.TRIP_TIME_PUSH_NOTIF_FAIL: {
      return Object.assign({}, state, {
        error: action.payload,
        sendingTripTimeUpdateNotification: false,
        sendingTripNotesUpdateNotification: false,
        success: undefined
      })
    }

    case constants.TRIP_OPERATOR_PUSH_NOTIF_REQUEST: {
      return Object.assign({}, state, {
        sendingTripOperatorUpdateNotification: true
      })
    }
    case constants.TRIP_OPERATOR_PUSH_NOTIF_SUCCESS_MESSAGE: {
      return Object.assign({}, state, {
        sendingTripOperatorUpdateNotification: false,
        success: action.payload
      })
    }
    case constants.TRIP_OPERATOR_PUSH_NOTIF_FAIL: {
      return Object.assign({}, state, {
        error: action.payload,
        sendingTripOperatorUpdateNotification: false,
        success: undefined
      })
    }

    case constants.ALLOTTED_TIME_PUSH_NOTIF_REQUEST: {
      return Object.assign({}, state, {
        sendingAllottedTimeNotification: true
      })
    }
    case constants.ALLOTTED_TIME_PUSH_NOTIF_SUCCESS_MESSAGE: {
      return Object.assign({}, state, {
        error: undefined,
        sendingAllottedTimeNotification: false,
        success: action.payload
      })
    }
    case constants.ALLOTTED_TIME_PUSH_NOTIF_FAIL: {
      return Object.assign({}, state, {
        error: action.payload,
        sendingAllottedTimeNotification: false,
        success: undefined
      })
    }

    case constants.TRIP_CANCEL_PUSH_NOTIF_REQUEST: {
      return Object.assign({}, state, {
        sendingTripCancelNotification: true
      })
    }
    case constants.TRIP_CANCEL_PUSH_NOTIF_SUCCESS_MESSAGE: {
      return Object.assign({}, state, {
        sendingTripCancelNotification: false,
        success: action.payload
      })
    }
    case constants.TRIP_CANCEL_PUSH_NOTIF_FAIL: {
      return Object.assign({}, state, {
        error: action.payload,
        sendingTripCancelNotification: false,
        success: undefined
      })
    }

    case constants.SAVE_DATA_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false
      })
    }

    case constants.GET_TRIPS_STATUS_COUNT_FAILURE:
    case constants.GET_DAILY_TRIP_LOG_FAILURE:
    case constants.GET_TOTAL_TRIPS_PER_SERVICE_FAILURE:
    case constants.GET_UBER_DRIVER_NUMBER_FAILURE:
    case constants.COMPLETE_TRIP_MANUALLY_FAILURE:
    case constants.CANCEL_BILLABLE_MANUALLY_FAILURE:
    case constants.TRIP_NO_SHOW_FAILURE:
    case constants.TRIP_CANCEL_FAILURE: {
      const error = action.payload
      return Object.assign({}, state, {
        error,
        isFetching: false
      })
    }

    case constants.IMPORT_TRIPS_SUCCESS: {
      const importResults = action.payload
      return { ...state, importResults }
    }
    case constants.TRIP_CREATE_SUCCESS: {
      const trip = action.payload
      const newItem = {}
      newItem[trip.id] = trip
      return Object.assign({}, state, {
        items: mergeMap(state.items, newItem)
      })
    }
    case constants.TRIP_GET_SUCCESS: {
      const trip = action.payload
      const newItem = {}
      newItem[trip.id] = trip
      return Object.assign({}, state, {
        items: mergeMap(state.items, newItem)
      })
    }
    case constants.TRIPS_FETCH_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case constants.TRIPS_FETCH_SUCCESS: {
      const tripsObj = {}
      action.payload.forEach(t => {
        tripsObj[t.id] = t
      })
      // Rearrange after forEach statement to prevent overriding the destinations(additional stop) data from redux state
      // since this api `/api/v1/trips/web` does not include the additional stop on its response by default
      if (state.currentTripId) {
        tripsObj[state.currentTripId] = state.items[state.currentTripId]
      }
      return Object.assign({}, state, {
        items: tripsObj,
        isFetching: false
      })
    }
    case constants.SET_TRIPS_EMPTY: {
      return Object.assign({}, state, {
        items: {},
        isFetching: false
      })
    }
    case constants.TRIPS_SUMMARY_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case constants.TRIPS_SUMMARY_SUCCESS: {
      const tripsObj = {}
      action.payload.items.forEach(t => {
        tripsObj[t.id] = t
      })

      return Object.assign({}, state, {
        isFetching: false,
        summaryResults: action.payload,
        summaryItems: tripsObj
      })
    }
    case constants.TRIPS_SUMMARY_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false,
        error: action.payload
      })
    }
    case constants.ZONE_TRIPS_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case constants.ZONE_TRIPS_SUCCESS: {
      const tripsObj = {}
      action.payload.forEach(t => {
        tripsObj[t.id] = t
      })
      return Object.assign({}, state, {
        items: tripsObj,
        isFetching: false
      })
    }

    case constants.RECENT_TRIPS_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }

    case constants.GET_UBER_DRIVER_NUMBER_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }

    case constants.RECENT_TRIPS_SUCCESS: {
      const recent = { ...state.recentTrips }
      recent[action.payload.riderId] = action.payload.recentTrips
      return Object.assign({}, state, {
        isFetching: false,
        recentTrips: recent
      })
    }

    case constants.UPDATE_TRIP_SUCCESS: {
      const { trip, stage } = action.payload
      const tripAsObject = {
        [trip.id]: trip
      }
      const updatedLastActiveTrips = getUpdatedTripsStages(state.items, state.lastActiveTrips, trip.id, stage)

      return Object.assign({}, state, {
        items: mergeMap(state.items, tripAsObject),
        lastActiveTrips: updatedLastActiveTrips
      })
    }
    case constants.ACTIVE_TRIPS_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case constants.ACTIVE_TRIPS_SUCCESS: {
      return Object.assign({}, state, {
        items: Object.assign({}, action.payload),
        isFetching: false
      })
    }
    case constants.ACTIVE_TRIPS_FAIL: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case constants.UPDATE_TRIP_FILTERS: {
      return Object.assign({}, state, {
        filters: { ...state.filters, ...action.payload }
      })
    }
    case constants.UPDATE_TRIP_SUMMARY_FILTERS: {
      return Object.assign({}, state, {
        summaryFilters: { ...state.summaryFilters, ...action.payload }
      })
    }
    case constants.UPDATE_TRIP_DRIVER: {
      return Object.assign({}, state, {
        updateDriverToggle: !state.updateDriverToggle
      })
    }
    case constants.SELECT_TRIP_ROWS: {
      return Object.assign({}, state, {
        selectedRows: { ...action.payload }
      })
    }
    case constants.FEEDBACK_FILTERS: {
      return Object.assign({}, state, {
        filters: { ...state.filters, ...action.payload }
      })
    }
    case constants.TRIPS_ORGANIZATION_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case constants.TRIPS_ORGANIZATION_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false
      })
    }
    case constants.TRIP_SHOW_MEMBERS: {
      const oldSettings = { ...state.settings }
      const settings = { showMembers: !oldSettings.showMembers }
      return Object.assign({}, state, {
        settings
      })
    }
    case constants.TRIP_HIDE_SHOW_MEMBERS: {
      const settings = { showMembers: true } // this should be set to true to hide members. a bit confusing but I might introduce bugs if I change this variable name
      return Object.assign({}, state, {
        settings
      })
    }
    case constants.SET_CURRENT_TRIP: {
      return Object.assign({}, state, {
        currentTripId: action.payload
      })
    }

    case constants.GET_UBER_DRIVER_NUMBER_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        requestedNumber: action.payload
      })
    }
    case constants.GET_DAILY_TRIP_LOG_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        dailyTripLogs: action.payload
      })
    }
    case constants.GET_TRIP_LOG_PER_SERVICE_AND_DATE_RANGE_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        dailyTripLogs: action.payload
      })
    }
    case constants.GET_TOTAL_TRIPS_PER_SERVICE_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        fetchTotalTripsPerService: action.payload
      })
    }
    case constants.GET_TRIPS_STATUS_COUNT_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        tripStatusCount: action.payload
      })
    }
    //Weather
    case constants.TRIP_WEATHER_UPDATES_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        weather: action.payload
      })
    }
    case constants.TRIP_WEATHER_UPDATES_FAIL: {
      return Object.assign({}, state, {
        isFetching: false
      })
    }

    case constants.FEEDBACK_STATUS_UPDATE_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }

    case constants.FEEDBACK_STATUS_UPDATE_SUCCESS: {
      console.log('success!', action)
      return Object.assign({}, state, {
        isFetching: false
      })
    }
    case constants.FEEDBACK_STATUS_UPDATE_FAILURE: {
      console.log('failed!', action)
      return Object.assign({}, state, {
        isFetching: false
      })
    }

    case constants.ROUTE_OPTIMIZATION_REQUEST: {
      return Object.assign({}, state, {
        isOptimizeTripLoading: true
      })
    }
    case constants.ROUTE_OPTIMIZATION_SUCCESS: {
      console.log('route opt reducer:', action.payload)
      return Object.assign({}, state, {
        isOptimizeTripLoading: false,
        optimizeRouteResponse: action.payload
      })
    }
    case constants.ROUTE_OPTIMIZATION_FAILURE: {
      console.log('route opt reducer:', action.payload)
      return Object.assign({}, state, {
        isOptimizeTripLoading: false,
        error: action.payload
      })
    }

    case constants.OPTIMIZE_TRIP_REQUEST: {
      return Object.assign({}, state, {
        isOptimizeTripLoading: true
      })
    }
    case constants.OPTIMIZE_TRIP_SUCCESS: {
      return Object.assign({}, state, {
        isOptimizeTripLoading: false,
        optimizeTripResponse: action.payload
      })
    }
    case constants.OPTIMIZE_TRIP_FAILURE: {
      return Object.assign({}, state, {
        isOptimizeTripLoading: false,
        error: action.payload.message
      })
    }
    case constants.GROUP_REQUESTED_SCHEDULED_TRIPS_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case constants.GROUP_REQUESTED_SCHEDULED_TRIPS_SUCCESS_MESSAGE: {
      console.log('success!', action)
      return Object.assign({}, state, {
        success: action.payload,
        isFetching: false
      })
    }
    case constants.GROUP_REQUESTED_SCHEDULED_TRIPS_FAILURE: {
      console.log('failed!', action)
      const error = action.payload
      return Object.assign({}, state, {
        error,
        isFetching: false
      })
    }

    // UNGROUP TRIPS PER SERVICE
    case constants.UNGROUP_REQUESTED_SCHEDULED_TRIPS_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case constants.UNGROUP_REQUESTED_SCHEDULED_TRIPS_SUCCESS_MESSAGE: {
      return Object.assign({}, state, {
        isFetching: false,
        success: action.payload
      })
    }
    case constants.UNGROUP_REQUESTED_SCHEDULED_TRIPS_FAILURE: {
      return Object.assign({}, state, {
        error: action.payload,
        isFetching: false
      })
    }

    case constants.GET_TEMPORARY_VEHICLES_REQUEST: {
      return Object.assign({}, state, {
        isItemsFetching: true
      })
    }
    case constants.GET_TEMPORARY_VEHICLES_SUCCESS: {
      return Object.assign({}, state, {
        isItemsFetching: false,
        temporaryVehicleResponse: action.payload
      })
    }
    case constants.GET_TEMPORARY_VEHICLES_FAILURE: {
      return Object.assign({}, state, {
        isItemsFetching: false,
        error: action.payload
      })
    }

    case constants.GET_SCHEDULED_REQUESTED_TRIPS_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case constants.GET_SCHEDULED_REQUESTED_TRIPS_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        scheduledReqiestTripsResponse: action.payload
      })
    }
    case constants.GROUP_REQUESTED_SCHEDULED_TRIPS_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false,
        error: action.payload
      })
    }

    case constants.GET_TEMP_VEHICLE_TRIPS_COUNT_REQUEST: {
      return Object.assign({}, state, {
        tempVehicleTripsCountFetching: true
      })
    }
    case constants.GET_TEMP_VEHICLE_TRIPS_COUNT_SUCCESS: {
      return Object.assign({}, state, {
        tempVehicleTripsCountFetching: false,
        tempVehicleTripsCountResponse: action.payload,
        success: action.payload
      })
    }
    case constants.GET_TEMP_VEHICLE_TRIPS_COUNT_FAILURE: {
      return Object.assign({}, state, {
        tempVehicleTripsCountFetching: false,
        error: action.payload
      })
    }

    case constants.GET_TEMPVEHICLES_PER_SERVICE_REQUEST: {
      return Object.assign({}, state, {
        isFetching: true
      })
    }
    case constants.GET_TEMPVEHICLES_PER_SERVICE_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        tempVehicleCountResponse: action.payload
      })
    }
    case constants.GET_TEMPVEHICLES_PER_SERVICE_FAILURE: {
      return Object.assign({}, state, {
        isFetching: false,
        error: action.payload
      })
    }
  }
  return state
}

const initialTripsHistoryState: ITripsHistory = {
  items: [],
  isFetching: false,
  error: '',
  activeColumns: [
    constants.TRIPS_HISTORY_COLUMNS.DATE,
    constants.TRIPS_HISTORY_COLUMNS.PICKUP_TIME,
    constants.TRIPS_HISTORY_COLUMNS.ARRIVAL_TIME,
    constants.TRIPS_HISTORY_COLUMNS.STATUS,
    constants.TRIPS_HISTORY_COLUMNS.RIDER_NAME,
    constants.TRIPS_HISTORY_COLUMNS.PROVIDER,
    constants.TRIPS_HISTORY_COLUMNS.SERVICE,
    constants.TRIPS_HISTORY_COLUMNS.COST,
    constants.TRIPS_HISTORY_COLUMNS.FARE
  ]
}

export function tripsHistory(state: ITripsHistory = initialTripsHistoryState, action: ITripAction): ITripsHistory {
  if (!action) {
    return state
  }

  switch (action.type) {
    case constants.TRIPS_HISTORY_REQUEST: {
      return Object.assign({}, state, { isFetching: true, items: {} })
    }
    case constants.TRIPS_HISTORY_SUCCESS: {
      return Object.assign({}, state, {
        isFetching: false,
        items: action.payload,
        lastUpdated: Date.now()
      })
    }
    case constants.TRIPS_HISTORY_FAILURE: {
      const error = action.payload
      return Object.assign({}, state, { isFetching: false, items: {}, error })
    }
    case constants.TRIPS_HISTORY_UPDATE_COLUMNS: {
      const columns = action.payload
      return Object.assign({}, state, { activeColumns: columns })
    }
    default:
      return state
  }
}

const getUpdatedTripsStages = (
  trips: IMap<IActiveTripResponseV2>,
  tripStages: IMap<ILastActiveTrips>,
  currentTripId: string,
  currentStage: string
) => {
  return Object.entries({ ...tripStages }).reduce(
    (acc, [stage, stageObject]) => {
      const tripExistsInCurrentStage = stageObject.items.some((it: string) => it === currentTripId)
      const copyOfStageObject = { ...stageObject }
      if (tripExistsInCurrentStage && stage !== currentStage) {
        copyOfStageObject.items = copyOfStageObject.items.filter((it: string) => it !== currentTripId)
        copyOfStageObject.total = copyOfStageObject.total - 1
      }
      if (!tripExistsInCurrentStage && stage === currentStage) {
        copyOfStageObject.items = [currentTripId, ...copyOfStageObject.items]
        copyOfStageObject.total = copyOfStageObject.total + 1
      }
      return { [stage]: copyOfStageObject, ...acc }
    },
    {} as ILastActiveTripsByStages
  )
}



// WEBPACK FOOTER //
// ./src/state/reducers/trips/index.ts